import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { formatDate, fromISODate } from '@/lib/utils/dateHelpers';
import type { Menu } from '@/types/api';

interface PublicPageCardProps {
  menu: Menu;
  statusBadge?: ReactNode;
  footer?: ReactNode;
}

function eventLabel(menu: Menu) {
  if (!menu.date) return '';
  return formatDate(fromISODate(menu.date), 'EEEE, MMMM d, yyyy');
}

export function PublicPageCard({ menu, statusBadge, footer }: PublicPageCardProps) {
  return (
    <Card className="shadow-lg border-stone-200/60 dark:border-stone-700/60">
      <CardContent className="space-y-4 pt-6">
        <div className={statusBadge ? 'space-y-2' : undefined}>
          {statusBadge ? <div className="flex flex-wrap items-center gap-2">{statusBadge}</div> : null}
          <div>
            <h1 className="text-2xl font-bold">{menu.title}</h1>
            <p className="text-sm text-muted-foreground">{eventLabel(menu)}</p>
            {menu.description && (
              <p className="mt-2 text-sm text-muted-foreground">{menu.description}</p>
            )}
          </div>
        </div>
        {footer}
      </CardContent>
    </Card>
  );
}
